import { mainSiteUrl } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20product%20research%20dashboard%20concept%20with%20laptop%20and%20tablet%20displaying%20organized%20category%20grids%20on%20warm%20sand%20colored%20desk%20surface%20morning%20sunlight%20casting%20soft%20diagonal%20shadows%20clean%20modern%20workspace%20aesthetic%20with%20abstract%20fashion%20product%20silhouettes%20editorial%20photography%20style&width=1800&height=900&seq=hero-main-bg-v2-7x9y&orientation=landscape"
          alt="SpreadsheetHub product showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-[42%] text-center lg:text-left">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Hipobuy Spreadsheet
              <span className="block font-heading italic font-normal text-white/90 mt-2 text-2xl md:text-4xl lg:text-5xl">
                The Ultimate Product Research Database
              </span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-white/75 leading-relaxed max-w-lg mx-auto lg:mx-0">
              Discover the latest Hipobuy Spreadsheet resources, product lists, QC guides,
              category rankings and shopping insights in one organized platform.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-7 py-3 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Explore Hipobuy Spreadsheet
                <div className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-7 py-3 rounded-full border-2 border-white/60 text-white text-sm font-semibold hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                View Product Categories
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              {['Updated Resources', 'Product Comparison Guides', 'Beginner Friendly', 'Independent Research Platform'].map((badge) => (
                <span key={badge} className="flex items-center gap-1.5 text-xs text-white/70">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-check-line text-white/80 text-xs"></i>
                  </div>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:w-[58%] w-full">
            <div className="bg-white/10 backdrop-blur-md rounded-3xl border border-white/20 p-5 md:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex gap-1.5">
                  <div className="w-3 h-3 rounded-full bg-accent-400"></div>
                  <div className="w-3 h-3 rounded-full bg-primary-400"></div>
                  <div className="w-3 h-3 rounded-full bg-secondary-400"></div>
                </div>
                <span className="text-white/60 text-xs font-label">Spreadsheet Database v2.0</span>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {[
                  { label: 'Shoes', count: '2.4k items', bg: 'bg-accent-500/20' },
                  { label: 'Hoodies', count: '1.8k items', bg: 'bg-primary-500/20' },
                  { label: 'Jackets', count: '1.2k items', bg: 'bg-secondary-500/20' },
                  { label: 'Accessories', count: '3.1k items', bg: 'bg-accent-500/20' },
                  { label: 'T-Shirts', count: '2.9k items', bg: 'bg-primary-500/20' },
                  { label: 'Bags', count: '1.5k items', bg: 'bg-secondary-500/20' },
                ].map((item) => (
                  <div key={item.label} className={`${item.bg} rounded-xl p-3 md:p-4 backdrop-blur-sm border border-white/10`}>
                    <p className="text-white text-sm font-semibold">{item.label}</p>
                    <p className="text-white/60 text-xs mt-1">{item.count}</p>
                    <div className="mt-2 flex items-center gap-1">
                      {[1, 2, 3, 4].map((star) => (
                        <div key={star} className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-white/50 text-[10px]"></i>
                        </div>
                      ))}
                      <span className="text-white/40 text-[10px] ml-1">QC Verified</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}